"use strict";

exports.__esModule = true;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = exports.SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = exports.SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = exports.isAuthorImageSupported = exports.isMultiplePagesSupported = exports.isLayoutNameTextOnImage = exports.isLayoutNameGrid = exports.isLayoutNameMobile = exports.isLayoutMobile = exports.isLayoutTextOnImage = exports.isLayoutFullPost = exports.isLayoutGrid = exports.isLayoutPGWithContentHeight = exports.isLayoutPGCardMedium = exports.isLayoutPGSideBySide = exports.isLayoutNameOneOfProGallery = exports.isLayoutProGallery = exports.getLayoutName = exports.OTHER_LAYOUT_TYPES = exports.LAYOUT_TYPES_MOBILE = exports.getLayoutTypeById = exports.LAYOUT_TYPES = exports.MOBILE_LAYOUT_NAMES = exports.LAYOUT_NAME_PG_GRID = exports.LAYOUT_NAME_PG_SIDE_BY_SIDE = exports.LAYOUT_NAME_PG_CARD_MEDIUM = exports.LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = exports.LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = exports.LAYOUT_NAME_ONE_COLUMN_MOBILE = exports.LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = exports.LAYOUT_NAME_GRID = exports.LAYOUT_NAME_SIDE_BY_SIDE = exports.LAYOUT_NAME_MOBILE = exports.LAYOUT_NAME_FULL_POST = exports.LAYOUT_NAME_CARD_PROFILE = exports.LAYOUT_NAME_CARD_LARGE = exports.LAYOUT_NAME_CARD_MEDIUM = exports.LAYOUT_NAME_CARD_SMALL = exports.SEO_LAYOUT_TYPE_FALLBACK = exports.getLayoutPaginationTypeNameById = exports.PAGINATION_TYPE_NAME_BY_ID = exports.PAGINATION_TYPE_WITH_PAGE_NUMBERS = exports.PAGINATION_TYPE_ON_SCROLL_DOWN = exports.getLayoutNameById = exports.LAYOUT_NAMES_BY_ID = exports.LAYOUT_PG_GRID = exports.LAYOUT_PG_SIDE_BY_SIDE = exports.LAYOUT_PG_CARD_MEDIUM = exports.LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_TEXT_ON_IMAGE_MOBILE = exports.LAYOUT_SIDE_BY_SIDE_MOBILE = exports.LAYOUT_ONE_COLUMN_MOBILE = exports.LAYOUT_TEXT_ON_IMAGE_MEDIUM = exports.LAYOUT_TEXT_ON_IMAGE_SMALL = exports.LAYOUT_GRID = exports.LAYOUT_SIDE_BY_SIDE = exports.LAYOUT_MOBILE = exports.LAYOUT_FULL_POST = exports.LAYOUT_CARD_PROFILE = exports.LAYOUT_CARD_LARGE = exports.LAYOUT_CARD_MEDIUM = exports.LAYOUT_CARD_SMALL = void 0;

var _lodash = require("lodash");

var _LAYOUT_NAMES_BY_ID, _PAGINATION_TYPE_NAME, _LAYOUT_TYPES, _LAYOUT_TYPES_MOBILE, _OTHER_LAYOUT_TYPES;

var LAYOUT_CARD_SMALL = 0;
exports.LAYOUT_CARD_SMALL = LAYOUT_CARD_SMALL;
var LAYOUT_CARD_MEDIUM = 1;
exports.LAYOUT_CARD_MEDIUM = LAYOUT_CARD_MEDIUM;
var LAYOUT_CARD_LARGE = 2;
exports.LAYOUT_CARD_LARGE = LAYOUT_CARD_LARGE;
var LAYOUT_CARD_PROFILE = 3;
exports.LAYOUT_CARD_PROFILE = LAYOUT_CARD_PROFILE;
var LAYOUT_FULL_POST = 4;
exports.LAYOUT_FULL_POST = LAYOUT_FULL_POST;
var LAYOUT_MOBILE = 5;
exports.LAYOUT_MOBILE = LAYOUT_MOBILE;
var LAYOUT_SIDE_BY_SIDE = 6;
exports.LAYOUT_SIDE_BY_SIDE = LAYOUT_SIDE_BY_SIDE;
var LAYOUT_GRID = 7;
exports.LAYOUT_GRID = LAYOUT_GRID;
var LAYOUT_TEXT_ON_IMAGE_SMALL = 8;
exports.LAYOUT_TEXT_ON_IMAGE_SMALL = LAYOUT_TEXT_ON_IMAGE_SMALL;
var LAYOUT_TEXT_ON_IMAGE_MEDIUM = 9;
exports.LAYOUT_TEXT_ON_IMAGE_MEDIUM = LAYOUT_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_ONE_COLUMN_MOBILE = 10;
exports.LAYOUT_ONE_COLUMN_MOBILE = LAYOUT_ONE_COLUMN_MOBILE;
var LAYOUT_SIDE_BY_SIDE_MOBILE = 11;
exports.LAYOUT_SIDE_BY_SIDE_MOBILE = LAYOUT_SIDE_BY_SIDE_MOBILE;
var LAYOUT_TEXT_ON_IMAGE_MOBILE = 12;
exports.LAYOUT_TEXT_ON_IMAGE_MOBILE = LAYOUT_TEXT_ON_IMAGE_MOBILE;
var LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = 13;
exports.LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM = LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_PG_CARD_MEDIUM = 14;
exports.LAYOUT_PG_CARD_MEDIUM = LAYOUT_PG_CARD_MEDIUM;
var LAYOUT_PG_SIDE_BY_SIDE = 15;
exports.LAYOUT_PG_SIDE_BY_SIDE = LAYOUT_PG_SIDE_BY_SIDE;
var LAYOUT_PG_GRID = 16;
exports.LAYOUT_PG_GRID = LAYOUT_PG_GRID;
var LAYOUT_NAMES_BY_ID = (_LAYOUT_NAMES_BY_ID = {}, _LAYOUT_NAMES_BY_ID[LAYOUT_CARD_SMALL] = 'Brick', _LAYOUT_NAMES_BY_ID[LAYOUT_CARD_MEDIUM] = 'Tiled', _LAYOUT_NAMES_BY_ID[LAYOUT_CARD_LARGE] = 'One column', _LAYOUT_NAMES_BY_ID[LAYOUT_FULL_POST] = 'Full post', _LAYOUT_NAMES_BY_ID[LAYOUT_SIDE_BY_SIDE] = 'Side by side', _LAYOUT_NAMES_BY_ID[LAYOUT_GRID] = 'Editorial', _LAYOUT_NAMES_BY_ID[LAYOUT_TEXT_ON_IMAGE_SMALL] = 'Postcard', _LAYOUT_NAMES_BY_ID[LAYOUT_TEXT_ON_IMAGE_MEDIUM] = 'Magazine', _LAYOUT_NAMES_BY_ID[LAYOUT_ONE_COLUMN_MOBILE] = 'Mobile One Column', _LAYOUT_NAMES_BY_ID[LAYOUT_SIDE_BY_SIDE_MOBILE] = 'Mobile Side By Side', _LAYOUT_NAMES_BY_ID[LAYOUT_TEXT_ON_IMAGE_MOBILE] = 'Mobile Magazine', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = 'Magazine Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_CARD_MEDIUM] = 'Tiled Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_SIDE_BY_SIDE] = 'Side by side Pro Gallery', _LAYOUT_NAMES_BY_ID[LAYOUT_PG_GRID] = 'Editorial Pro Gallery', _LAYOUT_NAMES_BY_ID);
exports.LAYOUT_NAMES_BY_ID = LAYOUT_NAMES_BY_ID;

var getLayoutNameById = function getLayoutNameById(layoutId) {
  return LAYOUT_NAMES_BY_ID[layoutId];
};

exports.getLayoutNameById = getLayoutNameById;
var PAGINATION_TYPE_ON_SCROLL_DOWN = 0;
exports.PAGINATION_TYPE_ON_SCROLL_DOWN = PAGINATION_TYPE_ON_SCROLL_DOWN;
var PAGINATION_TYPE_WITH_PAGE_NUMBERS = 1;
exports.PAGINATION_TYPE_WITH_PAGE_NUMBERS = PAGINATION_TYPE_WITH_PAGE_NUMBERS;
var PAGINATION_TYPE_NAME_BY_ID = (_PAGINATION_TYPE_NAME = {}, _PAGINATION_TYPE_NAME[PAGINATION_TYPE_ON_SCROLL_DOWN] = 'On scroll down', _PAGINATION_TYPE_NAME[PAGINATION_TYPE_WITH_PAGE_NUMBERS] = 'With page numbers', _PAGINATION_TYPE_NAME);
exports.PAGINATION_TYPE_NAME_BY_ID = PAGINATION_TYPE_NAME_BY_ID;

var getLayoutPaginationTypeNameById = function getLayoutPaginationTypeNameById(typeId) {
  return PAGINATION_TYPE_NAME_BY_ID[typeId];
};

exports.getLayoutPaginationTypeNameById = getLayoutPaginationTypeNameById;
var SEO_LAYOUT_TYPE_FALLBACK = LAYOUT_GRID;
exports.SEO_LAYOUT_TYPE_FALLBACK = SEO_LAYOUT_TYPE_FALLBACK;
var LAYOUT_NAME_CARD_SMALL = 'small';
exports.LAYOUT_NAME_CARD_SMALL = LAYOUT_NAME_CARD_SMALL;
var LAYOUT_NAME_CARD_MEDIUM = 'medium';
exports.LAYOUT_NAME_CARD_MEDIUM = LAYOUT_NAME_CARD_MEDIUM;
var LAYOUT_NAME_CARD_LARGE = 'large';
exports.LAYOUT_NAME_CARD_LARGE = LAYOUT_NAME_CARD_LARGE;
var LAYOUT_NAME_CARD_PROFILE = 'profile';
exports.LAYOUT_NAME_CARD_PROFILE = LAYOUT_NAME_CARD_PROFILE;
var LAYOUT_NAME_FULL_POST = 'full';
exports.LAYOUT_NAME_FULL_POST = LAYOUT_NAME_FULL_POST;
var LAYOUT_NAME_MOBILE = 'mobile';
exports.LAYOUT_NAME_MOBILE = LAYOUT_NAME_MOBILE;
var LAYOUT_NAME_SIDE_BY_SIDE = 'side-by-side';
exports.LAYOUT_NAME_SIDE_BY_SIDE = LAYOUT_NAME_SIDE_BY_SIDE;
var LAYOUT_NAME_GRID = 'grid';
exports.LAYOUT_NAME_GRID = LAYOUT_NAME_GRID;
var LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = 'text-on-image-small';
exports.LAYOUT_NAME_TEXT_ON_IMAGE_SMALL = LAYOUT_NAME_TEXT_ON_IMAGE_SMALL;
var LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = 'text-on-image-medium';
exports.LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM = LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_NAME_ONE_COLUMN_MOBILE = 'one-column-mobile';
exports.LAYOUT_NAME_ONE_COLUMN_MOBILE = LAYOUT_NAME_ONE_COLUMN_MOBILE;
var LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = 'side-by-side-mobile';
exports.LAYOUT_NAME_SIDE_BY_SIDE_MOBILE = LAYOUT_NAME_SIDE_BY_SIDE_MOBILE;
var LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = 'text-on-image-mobile';
exports.LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE = LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE;
var LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = 'pg-text-on-image-medium';
exports.LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM = LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM;
var LAYOUT_NAME_PG_CARD_MEDIUM = 'pg-medium';
exports.LAYOUT_NAME_PG_CARD_MEDIUM = LAYOUT_NAME_PG_CARD_MEDIUM;
var LAYOUT_NAME_PG_SIDE_BY_SIDE = 'pg-side-by-side';
exports.LAYOUT_NAME_PG_SIDE_BY_SIDE = LAYOUT_NAME_PG_SIDE_BY_SIDE;
var LAYOUT_NAME_PG_GRID = 'pg-grid';
exports.LAYOUT_NAME_PG_GRID = LAYOUT_NAME_PG_GRID;
var MOBILE_LAYOUT_NAMES = [LAYOUT_NAME_MOBILE, LAYOUT_NAME_ONE_COLUMN_MOBILE, LAYOUT_NAME_SIDE_BY_SIDE_MOBILE, LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE];
exports.MOBILE_LAYOUT_NAMES = MOBILE_LAYOUT_NAMES;
var LAYOUT_TYPES = (_LAYOUT_TYPES = {}, _LAYOUT_TYPES[LAYOUT_CARD_SMALL] = LAYOUT_NAME_CARD_SMALL, _LAYOUT_TYPES[LAYOUT_CARD_MEDIUM] = LAYOUT_NAME_CARD_MEDIUM, _LAYOUT_TYPES[LAYOUT_CARD_LARGE] = LAYOUT_NAME_CARD_LARGE, _LAYOUT_TYPES[LAYOUT_FULL_POST] = LAYOUT_NAME_FULL_POST, _LAYOUT_TYPES[LAYOUT_SIDE_BY_SIDE] = LAYOUT_NAME_SIDE_BY_SIDE, _LAYOUT_TYPES[LAYOUT_GRID] = LAYOUT_NAME_GRID, _LAYOUT_TYPES[LAYOUT_TEXT_ON_IMAGE_SMALL] = LAYOUT_NAME_TEXT_ON_IMAGE_SMALL, _LAYOUT_TYPES[LAYOUT_TEXT_ON_IMAGE_MEDIUM] = LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM, _LAYOUT_TYPES[LAYOUT_TEXT_ON_IMAGE_MOBILE] = LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE, _LAYOUT_TYPES[LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM, _LAYOUT_TYPES[LAYOUT_PG_CARD_MEDIUM] = LAYOUT_NAME_PG_CARD_MEDIUM, _LAYOUT_TYPES[LAYOUT_PG_SIDE_BY_SIDE] = LAYOUT_NAME_PG_SIDE_BY_SIDE, _LAYOUT_TYPES[LAYOUT_PG_GRID] = LAYOUT_NAME_PG_GRID, _LAYOUT_TYPES);
exports.LAYOUT_TYPES = LAYOUT_TYPES;

var getLayoutTypeById = function getLayoutTypeById(layoutId) {
  return LAYOUT_TYPES[layoutId];
};

exports.getLayoutTypeById = getLayoutTypeById;
var LAYOUT_TYPES_MOBILE = (_LAYOUT_TYPES_MOBILE = {}, _LAYOUT_TYPES_MOBILE[LAYOUT_ONE_COLUMN_MOBILE] = LAYOUT_NAME_ONE_COLUMN_MOBILE, _LAYOUT_TYPES_MOBILE[LAYOUT_SIDE_BY_SIDE_MOBILE] = LAYOUT_NAME_SIDE_BY_SIDE_MOBILE, _LAYOUT_TYPES_MOBILE[LAYOUT_TEXT_ON_IMAGE_MOBILE] = LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE, _LAYOUT_TYPES_MOBILE);
exports.LAYOUT_TYPES_MOBILE = LAYOUT_TYPES_MOBILE;
var OTHER_LAYOUT_TYPES = (_OTHER_LAYOUT_TYPES = {}, _OTHER_LAYOUT_TYPES[LAYOUT_CARD_PROFILE] = LAYOUT_NAME_CARD_PROFILE, _OTHER_LAYOUT_TYPES[LAYOUT_MOBILE] = LAYOUT_NAME_MOBILE, _OTHER_LAYOUT_TYPES);
exports.OTHER_LAYOUT_TYPES = OTHER_LAYOUT_TYPES;

var getLayoutName = function getLayoutName(layoutType) {
  return LAYOUT_TYPES[layoutType] || LAYOUT_TYPES_MOBILE[layoutType] || OTHER_LAYOUT_TYPES[layoutType];
};

exports.getLayoutName = getLayoutName;

var isLayoutProGallery = function isLayoutProGallery(layoutType) {
  return [LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_GRID].includes(Number(layoutType));
};

exports.isLayoutProGallery = isLayoutProGallery;

var isLayoutNameOneOfProGallery = function isLayoutNameOneOfProGallery(layoutName) {
  return [LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_NAME_PG_CARD_MEDIUM, LAYOUT_NAME_PG_SIDE_BY_SIDE, LAYOUT_NAME_PG_GRID].includes(layoutName);
};

exports.isLayoutNameOneOfProGallery = isLayoutNameOneOfProGallery;

var isLayoutPGSideBySide = function isLayoutPGSideBySide(layoutType) {
  return Number(layoutType) === LAYOUT_PG_SIDE_BY_SIDE;
};

exports.isLayoutPGSideBySide = isLayoutPGSideBySide;

var isLayoutPGCardMedium = function isLayoutPGCardMedium(layoutType) {
  return Number(layoutType) === LAYOUT_PG_CARD_MEDIUM;
};

exports.isLayoutPGCardMedium = isLayoutPGCardMedium;

var isLayoutPGWithContentHeight = function isLayoutPGWithContentHeight(layoutType) {
  return (0, _lodash.includes)([LAYOUT_PG_GRID, LAYOUT_PG_CARD_MEDIUM], Number(layoutType));
};

exports.isLayoutPGWithContentHeight = isLayoutPGWithContentHeight;

var isLayoutGrid = function isLayoutGrid(layoutType) {
  return Number(layoutType) === LAYOUT_GRID;
};

exports.isLayoutGrid = isLayoutGrid;

var isLayoutFullPost = function isLayoutFullPost(layoutType) {
  return Number(layoutType) === LAYOUT_FULL_POST;
};

exports.isLayoutFullPost = isLayoutFullPost;

var isLayoutTextOnImage = function isLayoutTextOnImage(layoutType) {
  return (0, _lodash.includes)([LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_TEXT_ON_IMAGE_MOBILE, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM], Number(layoutType));
};

exports.isLayoutTextOnImage = isLayoutTextOnImage;

var isLayoutMobile = function isLayoutMobile(layoutType) {
  return (0, _lodash.includes)([LAYOUT_MOBILE, LAYOUT_ONE_COLUMN_MOBILE, LAYOUT_SIDE_BY_SIDE_MOBILE], Number(layoutType));
};

exports.isLayoutMobile = isLayoutMobile;

var isLayoutNameMobile = function isLayoutNameMobile(layoutName) {
  return (0, _lodash.includes)(MOBILE_LAYOUT_NAMES, layoutName);
};

exports.isLayoutNameMobile = isLayoutNameMobile;

var isLayoutNameGrid = function isLayoutNameGrid(layoutName) {
  return layoutName === LAYOUT_NAME_GRID;
};

exports.isLayoutNameGrid = isLayoutNameGrid;

var isLayoutNameTextOnImage = function isLayoutNameTextOnImage(layoutName) {
  return (0, _lodash.includes)([LAYOUT_NAME_TEXT_ON_IMAGE_SMALL, LAYOUT_NAME_TEXT_ON_IMAGE_MEDIUM, LAYOUT_NAME_TEXT_ON_IMAGE_MOBILE, LAYOUT_NAME_PG_TEXT_ON_IMAGE_MEDIUM], layoutName);
};

exports.isLayoutNameTextOnImage = isLayoutNameTextOnImage;
var SUPPORTS_MULTIPLE_PAGES_PAGINATION = [LAYOUT_CARD_LARGE, LAYOUT_FULL_POST, LAYOUT_GRID, LAYOUT_MOBILE, LAYOUT_SIDE_BY_SIDE, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_ONE_COLUMN_MOBILE, LAYOUT_SIDE_BY_SIDE_MOBILE, LAYOUT_TEXT_ON_IMAGE_MOBILE, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_GRID];

var isMultiplePagesSupported = function isMultiplePagesSupported(layoutType) {
  return (0, _lodash.includes)(SUPPORTS_MULTIPLE_PAGES_PAGINATION, layoutType);
};

exports.isMultiplePagesSupported = isMultiplePagesSupported;

var isAuthorImageSupported = function isAuthorImageSupported(layoutId) {
  if ([LAYOUT_TEXT_ON_IMAGE_SMALL, LAYOUT_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM].includes(layoutId)) {
    return false;
  }

  return true;
};

exports.isAuthorImageSupported = isAuthorImageSupported;
var SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = 0;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT = SIDE_BY_SIDE_LAYOUT_IMAGE_LEFT;
var SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = 1;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT = SIDE_BY_SIDE_LAYOUT_IMAGE_RIGHT;
var SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = 2;
exports.SIDE_BY_SIDE_LAYOUT_IMAGE_NONE = SIDE_BY_SIDE_LAYOUT_IMAGE_NONE;